import React from "react";
import ReactDOM from "react-dom";
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom'
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";

import configureStore from "./app/store/configureStore";
import * as serviceWorker from "./serviceWorker";
const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/" component={App}/>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
